// «Vis antal ledige pladser» (OPG-0078), widget-udgaven. Spejler reglen i
// apps/holdstyring/src/lib/spots-display.ts (widget-pakken kan ikke importere app-koden):
// exact = som før, approximate = «Ledige pladser» / «Få pladser tilbage» (≤ 3 eller ≤ 20 %),
// full_only = intet om pladserne før holdet er fuldt. Fuldt hold vises som før.

export type SpotsDisplay = 'exact' | 'approximate' | 'full_only'

export function parseSpotsDisplay(value: unknown): SpotsDisplay {
  return value === 'approximate' || value === 'full_only' ? value : 'exact'
}

export function isFewSpots(left: number, capacity: number | null | undefined): boolean {
  if (left <= 0) return false
  if (left <= 3) return true
  return typeof capacity === 'number' && capacity > 0 && left / capacity <= 0.2
}

/** Tekst for et hold, der ikke er fuldt, eller null når intet skal vises. */
export function widgetSpotsText(
  left: number,
  capacity: number | null | undefined,
  mode: SpotsDisplay,
  strings: { spotsOpenLabel: string; spotsFewLabel: string },
  exact: () => string,
): string | null {
  if (left <= 0 || mode === 'full_only') return null
  if (mode === 'approximate') return isFewSpots(left, capacity) ? strings.spotsFewLabel : strings.spotsOpenLabel
  return exact()
}
